var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 43C8 42.4477 8.44772 42 9 42H39C39.5523 42 40 42.4477 40 43C40 43.5523 39.5523 44 39 44H9C8.44772 44 8 43.5523 8 43Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8H10V6H19V8Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 8H29V6H38V8Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 11H12V9H19V11Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 11H29V9H36V11Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 38H16V36H32V38Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 4H19C17.8954 4 17 4.89543 17 6V16C17 17.1046 17.8954 18 19 18H29C30.1046 18 31 17.1046 31 16V6C31 4.89543 30.1046 4 29 4ZM25 7V10H28V12H25V15H23V12H20V10H23V7H25Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 6V9L29 9V13H26V16H22V13H19V9H22V6H26ZM23 10H20V12H23V15H25V12H28V10H25V7H23V10ZM29 5H19C18.4477 5 18 5.44772 18 6V16C18 16.5523 18.4477 17 19 17H29C29.5523 17 30 16.5523 30 16V6C30 5.44772 29.5523 5 29 5ZM19 4H29C30.1046 4 31 4.89543 31 6V16C31 17.1046 30.1046 18 29 18H19C17.8954 18 17 17.1046 17 16V6C17 4.89543 17.8954 4 19 4Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H20V23H16V20Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25H20V28H16V25Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30H20V33H16V30Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H26V23H22V20Z",
    fill: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25H26V28H22V25Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H26V33H22V30Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20H32V23H28V20Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25H32V28H28V25Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H32V33H28V30Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 42V7H14V42H12Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 42V7H36V42H34Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 36H17V42H23V36ZM25 36V42H31V36H25Z",
    fill: "#333333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 42V38H31V42H29Z",
    fill: "#333333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 42V38H19V42H17Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.7b9e0a8de53b62bf2626af459670d9ea.svg";
export { ForwardRef as ReactComponent };